import {
  BulkUpdateLevelsDocument,
  BulkUpdateLevelsMutation,
  BulkUpdateLevelsMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useBulkUpdateLevels = () => {
  const [mutate, { loading }] = useMutation(BulkUpdateLevelsDocument, {
    extractorFn: (data: BulkUpdateLevelsMutation) =>
      data.jobCatalogMutations.bulkUpdateJobcatalogLevel,
  })

  const bulkUpdateLevels = (changes: BulkUpdateLevelsMutationVariables['changes']) => {
    return mutate({ variables: { changes } })
  }

  return { bulkUpdateLevels, isMutating: loading }
}

export default useBulkUpdateLevels
